module.exports = __webpack_public_path__ + "static/node.svg-15d9a3b7bfac4e7dbc3e5d50c2bce9be.png";